import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=c51464aa&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=c51464aa&prod&lang=scss&scoped=true"
import style1 from "./Info.vue?vue&type=style&index=1&id=c51464aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51464aa",
  null
  
)

export default component.exports